import { Plus } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button, MeasurementList, MeasurementForm, MeasurementFilters } from '../components'
import { useMeasurements } from '../hooks/useMeasurements'
import { useAuth } from '../contexts/AuthContextTest'

function Measurements() {
  const { user } = useAuth()
  const navigate = useNavigate()
  
  const {
    measurements,
    isLoading,
    totalItems,
    showModal,
    editingMeasurement,
    isCreating,
    isUpdating,
    searchTerm,
    setSearchTerm,
    handleSubmit,
    handleEdit,
    handleDelete,
    handleToggleStatus,
    handleCloseModal,
    handleClearFilters
  } = useMeasurements({}, user)

  // Check if user can create measurements
  const canCreateMeasurement = user?.role?.id === 1 || user?.role?.id === 2 // Super Admin and Company Owner can create measurements

  // Handle view measurement
  const handleView = (measurement) => {
    navigate(`/measurements/${measurement.id}`)
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-4xl font-bold text-secondary-900">Measurements</h1>
          <p className="mt-1 text-base text-secondary-600">
            Manage customer measurements and sizing information
          </p>
        </div>
        {canCreateMeasurement && (
          <Button
            onClick={() => handleEdit(null)}
            variant="primary"
            size="md"
        >
          <Plus className="h-4 w-4 mr-2" />
          Add Measurement
          </Button>
        )}
      </div>

      {/* Filters */}
      <MeasurementFilters
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        onClearFilters={handleClearFilters}
        totalItems={totalItems}
      />

      {/* Measurement List */}
      <MeasurementList
        measurements={measurements}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onToggleStatus={handleToggleStatus}
        onView={handleView}
        userRole={user?.role?.id}
      />

      {/* Measurement Form Modal */}
      <MeasurementForm
        isOpen={showModal}
        editingMeasurement={editingMeasurement}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        isLoading={isCreating || isUpdating}
      />
    </div>
  )
}

export default Measurements